import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { API, authHeaders, errText } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';
import { getRole } from '../auth';

const REASON_LABEL = {
  fake: 'Фейковый профиль',
  harassment: 'Домогательства/оскорбления',
  inappropriate_content: 'Неприемлемый контент',
  spam: 'Спам/реклама',
  underage: 'Несовершеннолетний',
  other: 'Другое',
};

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export default function Reports() {
  const navigate = useNavigate();
  const profilePath = getRole() === 'super_admin' ? '/applications' : '/clients';
  const [filter, setFilter] = useState('open');
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');

  const fetchItems = useCallback(() => {
    axios.get(`${API}/reports`, { headers: authHeaders(), params: filter ? { status: filter } : {} })
      .then(r => setItems(r.data));
  }, [filter]);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  const resolve = async (id) => {
    setError('');
    try {
      await axios.post(`${API}/reports/${id}/resolve`, {}, { headers: authHeaders() });
      fetchItems();
    } catch (e) {
      setError(errText(e, 'Не удалось отметить жалобу как рассмотренную'));
    }
  };

  return (
    <Layout>
      <h1 style={ui.title}>Жалобы</h1>
      <p style={{ color: colors.textMuted, fontSize: 13, marginTop: -10, marginBottom: 20 }}>
        Жалобы пользователей на анкеты/поведение — очередь на ручной разбор, без автоблокировки.
        При необходимости заблокируйте анкету отдельно, на странице клиента.
      </p>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button style={filter === 'open' ? ui.btn : ui.btnSecondary} onClick={() => setFilter('open')}>Открытые</button>
        <button style={filter === 'resolved' ? ui.btn : ui.btnSecondary} onClick={() => setFilter('resolved')}>Рассмотренные</button>
        <button style={filter === null ? ui.btn : ui.btnSecondary} onClick={() => setFilter(null)}>Все</button>
      </div>

      {error && <div style={{ ...ui.error, marginBottom: 16 }}>{error}</div>}

      {items === null ? (
        <div style={ui.empty}>Загрузка…</div>
      ) : items.length === 0 ? (
        <div style={ui.card}><div style={ui.empty}>Жалоб нет</div></div>
      ) : (
        items.map((r) => (
          <div key={r.id} style={ui.card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <div style={{ fontWeight: 600 }}>{REASON_LABEL[r.reason] || r.reason}</div>
              <div style={{ fontSize: 12, color: colors.textMuted }}>{fmt(r.created_at)}</div>
            </div>
            <div style={{ fontSize: 13, color: colors.textMuted, marginBottom: 6 }}>
              От:{' '}
              <span
                onClick={() => navigate(`${profilePath}?open=${r.reporter_id}`)}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                {r.reporter_name || 'Без имени'} (id {r.reporter_id})
              </span>
              {' '}— на:{' '}
              <span
                onClick={() => navigate(`${profilePath}?open=${r.target_id}`)}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                {r.target_name || 'Без имени'} (id {r.target_id})
              </span>
            </div>
            {r.text && <div style={{ fontSize: 14, marginBottom: 10 }}>{r.text}</div>}
            {r.status === 'resolved' ? (
              <div style={{ fontSize: 12, color: colors.textMuted }}>Рассмотрено: {r.resolved_by_name}</div>
            ) : (
              <button style={ui.btn} onClick={() => resolve(r.id)}>Отметить рассмотренной</button>
            )}
          </div>
        ))
      )}
    </Layout>
  );
}
